import React, { useRef, useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import { ChevronDown } from 'lucide-react';

const Result = () => {
    return (
        <Alert variant="success" className="success-msg">
            Your project estimate request has been successfully sent
        </Alert>
    );
};

const FormEstimateProject = () => {
    const form = useRef();
    const [result, showResult] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedProperty, setSelectedProperty] = useState('Residential Properties');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);

    const properties = [
        "Commercial Properties",
        "Residential Properties",
        "Master Communities",
        "Mall & Retail",
        "Hospitality",
        "Villas And Apartments",
        "Warehouses",
    ];

    const handleSelect = (property) => {
        setSelectedProperty(property);
        setIsOpen(false);
    };

    const sendEstimateRequest = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError(null);

        const formData = {
            projectName: form.current['project_name'].value,
            customerName: form.current['customer_name'].value,
            contactNumber: form.current['contact_number'].value,
            emailId: form.current['email'].value,
            propertyType: selectedProperty,
            serviceRequired: form.current['service_required'].value
        };

        try {
            const response = await fetch('https://ucwf-server-42s2.onrender.com/api/application/estimate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                throw new Error(`Server responded with status ${response.status}`);
            }

            // const data = await response.json();
            form.current.reset();
            setSelectedProperty('Residential Properties');
            showResult(true);
            
            // Hide success message after 5 seconds
            setTimeout(() => {
                showResult(false);
            }, 5000);
        } catch (err) {
            console.error('Error submitting estimate request:', err);
            setError('Failed to submit request. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <form ref={form} onSubmit={sendEstimateRequest} className="axil-contact-form">
            <div className="form-group">
                <label htmlFor="project_name">Project Name</label>
                <input 
                    type="text" 
                    className="form-control" 
                    name="project_name" 
                    required 
                />
            </div>
            <div className="form-group">
                <label htmlFor="customer_name">Customer Name</label>
                <input 
                    type="text" 
                    className="form-control" 
                    name="customer_name" 
                    required 
                />
            </div>
            <div className="form-group">
                <label htmlFor="contact_number">Contact Number</label>
                <input 
                    type="tel" 
                    className="form-control" 
                    name="contact_number" 
                    required 
                />
            </div>
            <div className="form-group">
                <label htmlFor="email">Email ID</label>
                <input 
                    type="email" 
                    className="form-control" 
                    name="email" 
                    required 
                />
            </div>
            
            <div className="form-group">
                <label>Property Type</label>
                <div className="ucwf-dropdown">
                    <input 
                        type="hidden" 
                        name="property_type" 
                        value={selectedProperty} 
                    />
                    <div className="ucwf-dropdown-header" onClick={() => setIsOpen(!isOpen)}>
                        <span>{selectedProperty}</span>
                        <button type="button" className="ucwf-dropdown-button">
                            <ChevronDown size={20} />
                        </button>
                    </div>
                    {isOpen && (
                        <div className="ucwf-dropdown-menu">
                            {properties.map((property) => (
                                <div
                                    key={property}
                                    className="ucwf-dropdown-item"
                                    onClick={() => handleSelect(property)}
                                >
                                    {property}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <div className="form-group">
                <label htmlFor="service_required">Service Required</label>
                <input 
                    type="text" 
                    className="form-control" 
                    name="service_required" 
                    required 
                />
            </div>
           
            <div className="form-group">
                <button 
                    type="submit" 
                    className="axil-btn btn-fill-primary btn-fluid btn-primary"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? 'Submitting...' : 'Submit Request'}
                </button>
            </div>
            <div className="form-group">
                {error && <Alert variant="danger">{error}</Alert>}
                {result ? <Result /> : null}
            </div>
        </form>
    );
};

export default FormEstimateProject;